import React from 'react'
import { makeStyles } from '@material-ui/styles'
import messages from '@utils/messages'
import CheckMarkCircleIcon from '@src/icons/CheckMarkCircleIcon'
import WarningCircleIcon from '@src/icons/WarningCircleIcon'
import { Theme, Typography } from '@material-ui/core'
import { Availability } from '@src/components/AvailabilityMessage/NCEAvailabilityMessage'
import { TrackedAvailabilityMessage } from '@src/components/TrackedAvailabilityMessage/TrackedAvailabilityMessage'

const useStyles = makeStyles((theme: Theme) => ({
  availabilityIcon: {
    marginRight: theme.spacing(2),
    fontSize: theme.typography.pxToRem(16),
    height: theme.typography.pxToRem(16),
  },
  messageText: {
    fontSize: theme.typography.pxToRem(12),
    minWidth: 'fit-content',
  },
}))

interface Props {
  availability?: Availability | null
  showLabel?: boolean
}

const AvailabilityStatus: React.FC<Props> = ({ availability, showLabel }) => {
  const classes = useStyles()

  switch (availability?.key) {
    case 'APO_NO_STOCK':
    case 'CONTACT_FOR_AVAILABILITY':
    case 'UNKNOWN_AVAILABILITY':
      return (
        <>
          <WarningCircleIcon
            className={classes.availabilityIcon}
            color="warning"
          />
          {showLabel && (
            <Typography className={classes.messageText}>
              <TrackedAvailabilityMessage
                {...messages.CONTACT_CUSTOMER_SVC}
                availability={availability}
              />
            </Typography>
          )}
        </>
      )
    case 'FULFILMENT_DELIVERY_DELAYED':
    case 'OUT_OF_STOCK_KEY':
      return (
        <>
          <WarningCircleIcon
            className={classes.availabilityIcon}
            color="warning"
          />
          {showLabel && (
            <Typography className={classes.messageText}>
              <TrackedAvailabilityMessage
                {...messages.DELAYED}
                availability={availability}
              />
            </Typography>
          )}
        </>
      )
    case 'AVAILABLE_TO_SHIP_ON':
    case 'ESTIMATED_TO_SHIP_ON':
    case 'LIMITED_AVAILABILITY':
    case 'ONLY_FEW_LEFT_IN_STOCK':
    case 'TPP_AVAILABILITY_MESSAGE':
      return (
        <>
          <CheckMarkCircleIcon
            className={classes.availabilityIcon}
            color="success"
          />
          {showLabel && (
            <Typography className={classes.messageText}>
              <TrackedAvailabilityMessage
                {...messages.IN_STOCK}
                availability={availability}
              />
            </Typography>
          )}
        </>
      )
    default:
      return null
  }
}

export default AvailabilityStatus
